export default {
    mounted (el) {
        // Store original styles and position
        const originalStyles = {
            position: el.style.position || '',
            top: el.style.top || '',
            right: el.style.right || ''
        }

        // Get the initial position of the element relative to its parent element
        const elRect = el.getBoundingClientRect()
        const parentRect = el.parentElement ? el.parentElement.getBoundingClientRect() : { top: 0, right: window.innerWidth }
        const offsetTop = elRect.top - parentRect.top
        const offsetRight = window.innerWidth - elRect.right

        // Set a flag to track sticky state
        let isSticky = false

        // Create a function to check and update the position
        const checkPosition = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop
            const parentTop = el.parentElement ? el.parentElement.getBoundingClientRect().top + scrollTop : 0

            if (scrollTop >= parentTop && !isSticky) {
                // Make it sticky
                el.style.position = 'fixed'
                el.style.top = `${offsetTop}px`
                el.style.right = `${offsetRight}px`
                isSticky = true
            } else if (scrollTop < parentTop && isSticky) {
                // Return to original state
                el.style.position = originalStyles.position
                el.style.top = originalStyles.top
                el.style.right = originalStyles.right
                isSticky = false
            }
        }

        // Initial position check
        checkPosition()

        // Add scroll event with throttling
        let ticking = false
        const scrollHandler = () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    checkPosition()
                    ticking = false
                })

                ticking = true
            }
        }

        window.addEventListener('scroll', scrollHandler)
        el._scrollHandler = scrollHandler
    },
    unmounted (el) {
        if (el._scrollHandler) {
            window.removeEventListener('scroll', el._scrollHandler)
            delete el._scrollHandler
        }
    }
}
